module.exports = __webpack_public_path__ + "static/nominet-trust-7f27bc0e7160bdbd13471bb2f82c19bf.svg";